import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { deletePrediction } from '../store/actions/prediction.actions';
import { environment } from '../../environments/environments';

export interface RoiData {
  labels: string[];
  period_days: number;
  platform_roi: number[];
  total_data_points: number;
  user_id: number;
  user_roi: number[];
}

@Injectable({
  providedIn: 'root'
})
export class PredictionService {
  private BASE_URL = environment.apiUrl + 'api';

  constructor(private http: HttpClient) { }

  getPredictionLikeStats(predictionId: number): Observable<any> {
    return this.http.get(`${this.BASE_URL}/like/prediction-stats/${predictionId}`);
  }

  getPredictionById(id: string): Observable<any> {
    let userId
    if (!id) {
      userId = JSON.parse(localStorage.getItem('user') || '{}').user_id
    } else {
      userId = id;

    }
    const url = `${this.BASE_URL}/predictions/user/${userId}/accessible`;
    return this.http.get<any>(url);
  }

  getUserHistoryPredictions(id: string): Observable<any> {
    const url = `${this.BASE_URL}/predictions/user/${id}/history`;
    return this.http.get<any>(url);
  }

  getPredictionDetails(predictionId: string, userId: string): Observable<any> {
    const url = `${this.BASE_URL}/predictions/${userId}/${predictionId}`;
    return this.http.get<any>(url);
  }

  markPredictionAsViewed(predictionId: string, userId: string): Observable<any> {
    const url = `${this.BASE_URL}/predictions/${userId}/mark-viewed/${predictionId}`;
    return this.http.post<any>(url, {});
  }

  getTotalViewedPredictions(userId: string): Observable<any> {
    const url = `${this.BASE_URL}/predictions/${userId}/viewed`;
    return this.http.get<any>(url);
  }

  likePredction(predictionId: string, userId: string): Observable<any> {
    const url = `${this.BASE_URL}/like/like-prediction`;
    return this.http.post<any>(url, { user_id: userId, prediction_id: predictionId });
  }

  dislikePredction(predictionId: string, userId: string): Observable<any> {
    const url = `${this.BASE_URL}/like/dislike-prediction`;
    return this.http.post<any>(url, { user_id: userId, prediction_id: predictionId });
  }

  createPrediction(prediction: {
    title: string;
    sport: number;
    competition: number;
    team_home: number;
    team_away: number;
    confidence_team_home: number;
    confidence_team_away: number;
    event_name: string;
    event_date: Date;
    analysis_text: string;
    created_by: number;
    price_jetons: number;
  }): Observable<any> {
    const url = `${this.BASE_URL}/predictions/create`;
    return this.http.post<any>(url, prediction);
  }

  editPrediction(predictionId: string, prediction: {

    sport: number;
    competition: number;
    team_home: number;
    team_away: number;
    confidence_team_home: number;
    confidence_team_away: number;
    event_name: string;
    cote: string;
    event_date: Date;
    analysis_text: string;
    result: boolean | null;
  }): Observable<any> {
    const url = `${this.BASE_URL}/predictions/admin/${predictionId}/edit`;
    return this.http.put<any>(url, prediction);
  }

  deletePrediction(predictionId: string): Observable<any> {
    const url = `${this.BASE_URL}/predictions/${predictionId}/delete`;
    return this.http.delete<any>(url);
  }


  removePredictionLikeOrDislike(predictionId: any, userId: any): Observable<any> {
    const url = `${this.BASE_URL}/like/remove-like-dislike`;
    return this.http.post<any>(url, { user_id: userId, prediction_id: predictionId });
  }

  requestCustomPrediction(predictionData: {
    user_id: number;
    event_date: string;
    team_home_name: string;
    team_away_name: string;
    sport_name: string;
    competition_name?: string;
  }): Observable<any> {
    return this.http.post(`${this.BASE_URL}/purchase/request-custom-prediction`, predictionData);
  }


  getPurchaseRequests(): Observable<any> {
    const url = `${this.BASE_URL}/purchase/admin/pending-requests`;
    return this.http.get<any>(url);
  }

  markRequestAsProcessed(requestId: number): Observable<any> {
    const url = `${this.BASE_URL}/purchase/${requestId}/mark-request-processed`;
    return this.http.post<any>(url, {});
  }

  markRequestAsCancelled(requestId: number, note: string): Observable<any> {
    const url = `${this.BASE_URL}/purchase/${requestId}/mark-request-cancelled`;
    return this.http.post<any>(url, { note });
  }


  fulfillPurchaseRequest(requestId: number, predictionData: {
    title: string;
    sport: number;
    competition: number;
    team_home: number;
    team_away: number;
    confidence_team_home: number;
    confidence_team_away: number;
    event_name: string;
    event_date: Date;
    analysis_text: string;
    created_by: number;
    price_jetons: number;
    is_prediction_purchased?: boolean;
  }): Observable<any> {
    const url = `${this.BASE_URL}/purchase/admin/fulfill-request/${requestId}`;
    return this.http.post<any>(url, predictionData);
  } 

  getCombinedRoi(userId: number, periodDays: number = 30): Observable<RoiData> {
    return this.http.get<RoiData>(`${this.BASE_URL}/predictions/roi/daily/${userId}?period_days=${periodDays}`);
  }

  
  





}